<template>
  <div v-if="suggestions.length > 0" class="text-suggestions-panel mt-2">
    <div class="text-subtitle-2 mb-1">{{ $t('annotate.text_suggestions_title') }} ({{ suggestions.length }})</div>
    <v-list density="compact">
      <v-list-item v-for="s in suggestions" :key="'ts-' + s.id">
        <v-list-item-title>{{ suggestionTitle(s) }}</v-list-item-title>
        <v-list-item-subtitle v-if="suggestionSubtitle(s)">{{ suggestionSubtitle(s) }}</v-list-item-subtitle>
        <template #append>
          <div class="d-flex">
            <v-btn icon size="x-small" color="primary" :loading="loading" @click="$emit('accept', [s.id])">
              <v-icon size="small">mdi-check</v-icon>
            </v-btn>
            <v-btn icon size="x-small" :loading="loading" @click="$emit('reject', [s.id])">
              <v-icon size="small">mdi-close</v-icon>
            </v-btn>
          </div>
        </template>
      </v-list-item>
    </v-list>
    <v-btn size="small" color="primary" class="mt-1 mr-2" :loading="loading" @click="$emit('accept-all')">
      {{ $t('annotate.text_suggestions_accept_all') }}
    </v-btn>
    <v-btn size="small" variant="outlined" :loading="loading" @click="$emit('reject-all')">
      {{ $t('annotate.text_suggestions_reject_all') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TextSuggestionsPanel',
  props: {
    suggestions: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  methods: {
    parseSuggestion(s) {
      try {
        return JSON.parse(s.suggestion || '{}');
      } catch (e) {
        return {};
      }
    },
    suggestionTitle(s) {
      const p = this.parseSuggestion(s);
      if (p.action === 'suggest_transcript') {
        return this.$t('annotate.text_suggestion_transcript');
      }
      return this.$t('annotate.text_suggestion_box');
    },
    suggestionSubtitle(s) {
      const p = this.parseSuggestion(s);
      if (p.transcript) {
        return String(p.transcript);
      }
      if (p.coords && Array.isArray(p.coords)) {
        return p.coords.map((c) => c.toFixed(3)).join(', ');
      }
      return '';
    },
  },
};
</script>
